import baseline from './baseline';
import is6601CitMitTest from './6601-cit-mit-test';
import is6568iOSIAPTest from './6568-ios-iap-test';
import is6682GooglePlayTest from './6682-google-play-test';

export default {
  baseline,
  '6601-cit-mit-test': is6601CitMitTest,
  '6568-ios-iap-test': is6568iOSIAPTest,
  '6682-google-play-test': is6682GooglePlayTest,
};
